import React from 'react';

export const UpvoteThumb: React.FC = () => (
  <svg width='11' height='14' fill='none' viewBox='0 0 11 14'>
    <path
      fillRule='evenodd'
      d='M0 10.359C0 9.393.065 8 .295 7.614c.23-.387 2.233-2.304 2.88-3.864C3.823 2.19 3.935 0 4.998 0c1.064 0 1.412.835 1.3 2.549-.113 1.714-.904 2.772-.348 3.19.378.284 1.044-.18 2.66-.18.704 0 1.89 0 1.89.978 0 .979-.208.866-.303 1.53-.095.665.191.987-.124 1.736-.316.75-.704.842-.885 1.379-.18.536-.117 1.113-.962 1.9-.844.786-2.192.918-3.228.918-1.035 0-4.11-.36-4.534-1.375C.04 11.609 0 11.239 0 10.359z'
      clipRule='evenodd'
    ></path>
  </svg>
);
